"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exitWith = exports.ExitCode = void 0;
var ExitCode;
(function (ExitCode) {
    ExitCode["VulnerabilitiesFound"] = "VULNS";
    ExitCode[ExitCode["Error"] = 2] = "Error";
    ExitCode[ExitCode["NoSupportedFiles"] = 3] = "NoSupportedFiles";
})(ExitCode = exports.ExitCode || (exports.ExitCode = {}));
function exitWith(exitCode, message, testResults = []) {
    const err = new Error();
    err.message = message;
    err.code = exitCode.valueOf();
    if (0 < testResults.length) {
        const jsonData = testResults.length === 1 ? testResults[0] : testResults;
        err.jsonStringifiedResults = JSON.stringify(jsonData);
    }
    throw err;
}
exports.exitWith = exitWith;
//# sourceMappingURL=error.js.map